import React from "react";
import TeamCard from "./TeamCard";
import WeiJuinProfilePic from "../../images/WeiJuinProfilePic.jpg";
import HansProfilePic from "../../images/HansProfilePic.jpg";
import JabezProfilePic from "../../images/JabezProfilePic.png";
import { wizardhat } from "../AnimationRunner/anim1";
import { wand } from "../AnimationRunner/anim1";
import { cowboyhat } from "../AnimationRunner/anim1";
import { scarf } from "../AnimationRunner/anim1";
import { lasso } from "../AnimationRunner/anim1";
import { moustache } from "../AnimationRunner/anim1";
import { frenchhat } from "../AnimationRunner/anim1";

import {
  Animation,
  FORWARD,
  FORWARD_REVERSE,
} from "../AnimationRunner/AnimationRunner";

export default function TeamsSection({ ...props }) {
  return (
    <section className="container mx-auto py-10" {...props}>
      <h2 className="text-3xl font-bold text-center pb-10">Team</h2>
      <div className="flex md:flex-row flex-col md:justify-center justify-start md:space-x-6 md:space-y-0 space-y-10">
        <div className="relative">
          <TeamCard
            name="Lee Wei Juin"
            skills={["Backend", "Python", "Golang"]}
            image={WeiJuinProfilePic}
            mailHref="mailto:weijuinlee@kuhaku.tech"
            linkedinHref="https://www.linkedin.com/in/leeweijuin/"
          />
          <Animation
            animationData={wand}
            type={FORWARD}
            frameSpeed={10}
            delay={0}
            lineWidth={20}
            className="w-40 h-40 absolute top-10 left-1 md:-left-2 md:top-10 lg:left-2 lg:top-12 upDownAnimation"
          ></Animation>
          <Animation
            animationData={wizardhat}
            type={FORWARD}
            frameSpeed={100}
            delay={0}
            lineWidth={20}
            className="w-40 h-40 absolute -top-11 left-9 md:left-7 md:-top-10 lg:left-11 lg:-top-8"
          ></Animation>
        </div>
        <div className="relative">
          <TeamCard
            name="Hans Delano"
            skills={["Frontend", "React", "Angular"]}
            image={HansProfilePic}
            mailHref="mailto:hansdelano@kuhaku.tech"
            linkedinHref="https://www.linkedin.com/in/hans-delano/"
          />
          <Animation
            animationData={cowboyhat}
            type={FORWARD}
            frameSpeed={10}
            delay={0}
            lineWidth={20}
            className="w-36 h-36 absolute -top-9 left-8 md:left-5 md:-top-8 lg:left-8 lg:-top-6"
          ></Animation>
          <Animation
            animationData={scarf}
            type={FORWARD}
            frameSpeed={10}
            delay={0}
            lineWidth={20}
            className="w-36 h-36 absolute top-14 left-16 md:left-14 md:top-12 lg:left-20 lg:top-16"
          ></Animation>
          <Animation
            animationData={lasso}
            type={FORWARD_REVERSE}
            frameSpeed={10}
            delay={0}
            lineWidth={20}
            className="w-40 h-40 absolute top-10 -left-10 md:-left-14 md:top-10 lg:-left-10 lg:top-12"
          ></Animation>
        </div>
        <div className="relative">
          <TeamCard
            name="Jabez Tho"
            skills={["Backend", "C++", "C"]}
            image={JabezProfilePic}
            mailHref="mailto:jabeztho@kuhaku.tech"
            linkedinHref="https://www.linkedin.com/in/jabez-tho-6b49a0184/"
          />
          <Animation
            animationData={frenchhat}
            type={FORWARD}
            frameSpeed={100}
            delay={0}
            lineWidth={20}
            className="w-40 h-40 absolute -top-2 left-9 md:left-7 md:-top-1 lg:left-11 lg:top-1"
          ></Animation>
          <Animation
            animationData={moustache}
            type={FORWARD}
            frameSpeed={10}
            delay={0}
            lineWidth={20}
            className="w-40 h-40 absolute top-8 left-12 md:left-10 md:top-9 lg:left-14 lg:top-11 mustacheWagAnimation"
          ></Animation>
        </div>
      </div>
    </section>
  );
}
